import { useTranslation } from 'react-i18next';
import { allocationService } from '../services/allocationService';
import type { PoolFilters } from '../types/Checks';
import type { ScopedExportRequest } from '../types/Filters';
import type { PoolColumn } from './usePoolColumns';
import { useSpreadsheetExport } from './useSpreadsheetExport';

/** Filtros, ordenação e colunas valem nos dois escopos; `page` leva também a página e o tamanho dela. */
export function useExportPool(
  { page, perPage, ...filters }: PoolFilters,
  columns: readonly PoolColumn[],
) {
  const { t } = useTranslation('alocacao');
  return useSpreadsheetExport<ScopedExportRequest>(
    ({ scope, ...options }) =>
      allocationService.exportPool(scope === 'page' ? { ...filters, page, perPage } : filters, {
        ...options,
        columns,
      }),
    t('consultas.pool.nomeArquivo'),
  );
}
